




















































import { Vue, Component, Prop } from "vue-property-decorator";
import store from "@/store/modules/authentication";

@Component({})
export default class ChartsNav extends Vue {
  public isMini: boolean = false;

  public currentPageRoute: string = "";

  public get getToken() {
    return this.$store.getters["authentication/getToken"];
  }

  public get getCurrentPageRoute() {
    return this.currentPageRoute;
  }
  public set getCurrentPageRoute(val) {
    this.currentPageRoute = val;
  }

  private get getIsMini() {
    return this.isMini;
  }

  private pushRoute(route: string) {
    this.getCurrentPageRoute = route;
    var targetIframe = document.getElementById("diy-iframe").contentWindow;
    targetIframe.postMessage(
      { token: this.getToken, route: route },
      process.env.VUE_APP_IFRAME_RECEIVE_EMIT
    );
  }

  private resetCollapses() {}

  private created() {}
}
